import Select, { MultiValue, components } from 'react-select';
import { FC, FocusEvent, useEffect, useState } from 'react';
import { Option } from 'shared/types';
import { getColourStyles } from './styles';

interface SelectTagProps {
	options: any[];
	value?: any[];
	readonly?: boolean;
	tagColor?: string;
	placeholder?: string;
	onSelect?: (value: MultiValue<Option>) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>, selector?: string) => void;
}

//TODO поменять типы на нормальные
const MultiValueRemove: FC<any> = props => {
	return <components.MultiValueRemove {...props} />;
};

const Menu: FC<any> = props => {
	return <components.Menu {...props} />;
};

export const SelectTag: FC<SelectTagProps> = ({
	options,
	value = [],
	readonly = false,
	tagColor,
	placeholder = 'Select',
	onSelect,
  onFocus
}) => {
	const [selectedOption, setSelectedOption] = useState<MultiValue<unknown>>(
		[],
	);

	useEffect(() => {
		if (value.length) {
			setSelectedOption(value);
		} else {
			setSelectedOption([]);
		}
	}, [value, setSelectedOption]);

	const selectOption = (value: MultiValue<unknown>) => {
		const val = value as MultiValue<Option>;
		setSelectedOption(val);
		onSelect && onSelect(val);
	};

	return (
		<Select
			isMulti
			name="colors"
			placeholder={placeholder}
			options={options}
			value={selectedOption}
			onChange={selectOption}
			className="basic-multi-select"
			classNamePrefix="select"
			styles={{ ...getColourStyles(readonly, tagColor) }}
			menuPortalTarget={document.body}
			menuPosition="fixed"
			components={{
				MultiValueRemove: readonly ? () => null : MultiValueRemove,
				Menu: readonly ? () => null : Menu,
			}}
			isClearable={!readonly}
      onFocus={event=>onFocus && onFocus(event, '.basic-multi-select')}
		/>
	);
};
